<style>
  .headers {
    background: #fff;
  }

  .headers-inner .cell {
    background: #fff;

    padding: 12px 8px;
    font-size: 12px;
    font-family: proxima-nova, sans-serif;
    -webkit-font-smoothing: auto;
  }

  .project-event-dates .cell {
    padding: 12px 8px;
    font-size: 12px;
    font-family: proxima-nova, sans-serif;
    -webkit-font-smoothing: auto;
    background: #fbfbfb;
    border: 2px solid transparent;
    height: 100%;
  }

  .project-event-dates .cell span {
    border-radius: 50%;
    background: #fff;
    display: inline-flex;
    height: 35px;
    width: 35px;
    font-size: 10px;
    align-items: center;
    justify-content: center;
  }

  .project-event-dates .cell span.enabled {
    background: #4bb543;
    color: #fff;
  }

  .project-event-dates .cell span.enabled a {
    color: #fff;
  }

  .project-event-dates .cell span.draft.enabled {
    background: #797878;
    color: #fff;
  }

  .project-event-dates .cell span a {
    color: #fff;
  }

  :global(.project-event-dates a) {
    color: #fff;
  }

  a {
    color: #fff;
  }

  .project-details .cell {
    background: #fbfbfb;
    padding: 12px 8px;
    font-size: 11px;
    font-family: proxima-nova, sans-serif;
    height: 100%;
  }

  .project-details {
    height: 70px;
  }

  .project-event-dates {
    height: 70px;
  }

  .project {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  :global(.form) {
    padding: 8px 16px;
  }
</style>

<script>
  import { onMount, getContext } from 'svelte';
  import Card from '../../components/containers/card';
  import Download from '../../components/buttons/downloads';
  import AppLink from '../../utils/link';
  import Form from '../../components/inputs/form';
  import Loader from '../../components/ui/loader.html';

  import { PROGRAMS_PLAN } from '../../graphql/programs';
  import moment from 'moment';

  const projects = [{}];
  const client = getContext('apollo');

  let programs = [];
  let loading = true;
  let year = moment().format('YYYY');

  async function getPrograms() {
    loading = true;

    try {
      const { data } = await client.query({
        query: PROGRAMS_PLAN,
        variables: {
          eventSearch: {
            startDate: `${year}-01-01T00:00:00.000Z`,
            endDate: `${year}-12-31T23:59:59.000Z`
          }
        }
      });

      programs = data.programs.docs;
      loading = false;
    } catch (e) {
      loading = false;
      error = e;
    }
  }

  function hasEventForMonth(program, month) {
    const event = program.events.find(event => {
      return moment(event.date).month() === month;
    });

    return event;
  }

  function eventLinkForMonth(program, month) {
    const event = program.events.find(event => {
      return moment(event.date).month() === month;
    });

    return event ? `/events/view/${event.id}` : '#';
  }

  function isDraftForMonth(program, month) {
    const event = program.events.find(event => {
      return moment(event.date).month() === month;
    });

    if (event && event.published) return false;

    return true;
  }

  function hasEventLeader(program) {
    const event = program.events.find(e => {
      return e.leader !== null;
    });

    return event;
  }

  function getDownloadLink() {
    return `${GRAPHQL_API}/exports/program-plan`
  }


  onMount(getPrograms);
</script>

{#if loading} <Loader /> {:else}
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-5">
    <form>
      <div class="form-group">
        <label>Calendar Year</label>
        <select on:change="{getPrograms}" bind:value="{year}">
          <option>2018</option>
          <option>2019</option>
          <option>2020</option>
          <option>2021</option>
          <option>2022</option>
        </select>
      </div>
    </form>
  </div>
  <div class="cell small-12 medium-7 text-right">
    <a href="{getDownloadLink()}" target="_blank">
      <Download class="button primary" label="DOWNLOAD PROGRAM PLAN" />
    </a>
  </div>
  <div class="cell small-5">
    <div class="grid-x headers-inner">
      <div class="cell small-4">
        Program
      </div>
      <div class="cell small-4">
        Coordinator
      </div>
      <div class="cell small-2">
        Capacity
      </div>
      <div class="cell small-2">
        Support
      </div>
    </div>
  </div>
  <div class="cell small-7">
    <div class="grid-x headers-inner">
      <div class="cell small-1 text-center">
        Jan
      </div>
      <div class="cell small-1 text-center">
        Feb
      </div>
      <div class="cell small-1 text-center">
        Mar
      </div>
      <div class="cell small-1 text-center">
        Apr
      </div>
      <div class="cell small-1 text-center">
        May
      </div>
      <div class="cell small-1 text-center">
        Jun
      </div>
      <div class="cell small-1 text-center">
        Jul
      </div>
      <div class="cell small-1 text-center">
        Aug
      </div>
      <div class="cell small-1 text-center">
        Sep
      </div>
      <div class="cell small-1 text-center">
        Oct
      </div>
      <div class="cell small-1 text-center">
        Nov
      </div>
      <div class="cell small-1 text-center">
        Dec
      </div>
    </div>
  </div>
</div>

{#each programs as program, i}
<div class="grid-x grid-margin-x project">
  <div class="cell small-5">
    <div class="grid-x project-details">
      <div class="cell small-4">
        {program.name}
      </div>
      <div class="cell small-4">
        {program.coordinator ? program.coordinator.firstName : ''}
        {program.coordinator ? program.coordinator.lastName : ''}
      </div>
      <div class="cell small-2">
        {program.constraints.capacity}
      </div>
      <div class="cell small-2">
        {program.constraints.staff}
      </div>
    </div>
  </div>
  <div class="cell small-7">
    <div class="grid-x project-event-dates">
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 0)}"
          class:enabled="{hasEventForMonth(program, 0)}"
        >
          {#if hasEventForMonth(program, 0)}
          <AppLink href="{eventLinkForMonth(program, 0)}">
            {moment(hasEventForMonth(program,0).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 1)}"
          class:enabled="{hasEventForMonth(program, 1)}"
        >
          {#if hasEventForMonth(program, 1)}
          <AppLink href="{eventLinkForMonth(program,1)}">
            {moment(hasEventForMonth(program,1).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 2)}"
          class:enabled="{hasEventForMonth(program, 2)}"
        >
          {#if hasEventForMonth(program, 2)}
          <AppLink href="{eventLinkForMonth(program, 2)}">
            {moment(hasEventForMonth(program,2).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 3)}"
          class:enabled="{hasEventForMonth(program, 3)}"
        >
          {#if hasEventForMonth(program, 3)}
          <AppLink href="{eventLinkForMonth(program, 3)}">
            {moment(hasEventForMonth(program,3).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 4)}"
          class:enabled="{hasEventForMonth(program, 4)}"
        >
          {#if hasEventForMonth(program, 4)}
          <AppLink href="{eventLinkForMonth(program, 4)}">
            {moment(hasEventForMonth(program,4).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 5)}"
          class:enabled="{hasEventForMonth(program, 5)}"
        >
          {#if hasEventForMonth(program, 5)}
          <AppLink href="{eventLinkForMonth(program, 5)}">
            {moment(hasEventForMonth(program,5).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 6)}"
          class:enabled="{hasEventForMonth(program, 6)}"
        >
          {#if hasEventForMonth(program, 6)}
          <AppLink href="{eventLinkForMonth(program, 6)}">
            {moment(hasEventForMonth(program,6).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 7)}"
          class:enabled="{hasEventForMonth(program, 7)}"
        >
          {#if hasEventForMonth(program, 7)}
          <AppLink href="{eventLinkForMonth(program, 7)}">
            {moment(hasEventForMonth(program,7).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 8)}"
          class:enabled="{hasEventForMonth(program, 8)}"
        >
          {#if hasEventForMonth(program, 8)}
          <AppLink href="{eventLinkForMonth(program, 8)}">
            {moment(hasEventForMonth(program,8).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 9)}"
          class:enabled="{hasEventForMonth(program, 9)}"
        >
          {#if hasEventForMonth(program, 9)}
          <AppLink href="{eventLinkForMonth(program, 9)}">
            {moment(hasEventForMonth(program,9).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 10)}"
          class:enabled="{hasEventForMonth(program, 10)}"
        >
          {#if hasEventForMonth(program, 10)}
          <AppLink href="{eventLinkForMonth(program, 10)}">
            {moment(hasEventForMonth(program,10).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
      <div class="cell small-1 text-center">
        <span
          class:draft="{isDraftForMonth(program, 11)}"
          class:enabled="{hasEventForMonth(program, 11)}"
        >
          {#if hasEventForMonth(program, 11)}
          <AppLink href="{eventLinkForMonth(program, 11)}">
            {moment(hasEventForMonth(program,11).date).format('MM/DD')}
          </AppLink>
          {/if}
        </span>
      </div>
    </div>
  </div>
</div>
{/each} {/if}
